import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const usePinnedEvents = () => {
  return useQuery({
    queryKey: ["pinned-events"],
    queryFn: async () => {
      const now = new Date().toISOString();
      
      const { data, error } = await supabase
        .from("bitcoin_events")
        .select("*")
        .eq("is_active", true)
        .gte("event_date", now)
        .not("homepage_pin_expires_at", "is", null)
        .gte("homepage_pin_expires_at", now)
        .order("event_date", { ascending: true })
        .limit(3);

      if (error) throw error;
      return data;
    },
  });
};
